import { render, staticRenderFns } from "./conttemplat.vue?vue&type=template&id=70092b50&scoped=true"
import script from "./conttemplat.vue?vue&type=script&lang=js"
export * from "./conttemplat.vue?vue&type=script&lang=js"
import style0 from "./conttemplat.vue?vue&type=style&index=0&id=70092b50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70092b50",
  null
  
)

export default component.exports